import styled from 'styled-components';

export const CloseIconBox = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
`;

export const BannerTitleBox = styled.div`
  position: absolute;
  top: 42px;
  padding: 18px;
  text-align: center;
  width: 100%;
`;

export const ActivateButtonBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  height: 48px;
  position: absolute;
  z-index: 5;
  bottom: 18px;
  width: calc(100% - 36px);
`;
